import script from "./Describe.vue?vue&type=script&setup=true&lang=ts"
export * from "./Describe.vue?vue&type=script&setup=true&lang=ts"

import "./Describe.vue?vue&type=style&index=0&id=6fbfcc7c&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fbfcc7c"]])

export default __exports__